module.exports = __webpack_public_path__ + "static/media/New-order Icon.9dfb2540.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/New-order Icon.png
// module id = 605
// module chunks = 0